import log from 'loglevel';
import csCz from './locales/cs_CZ/messages.js';
import daDk from './locales/da_DK/messages.js';
import deCh from './locales/de_CH/messages.js';
import enGb from './locales/en_GB/messages.js';
import enUs from './locales/en_US/messages.js';
import esMx from './locales/es_MX/messages.js';
import frCh from './locales/fr_CH/messages.js';
import itCh from './locales/it_CH/messages.js';
import jaJp from './locales/ja_JP/messages.js';
import koKr from './locales/ko_KR/messages.js';
import noNo from './locales/no_NO/messages.js';
import plPl from './locales/pl_PL/messages.js';
import ptBr from './locales/pt_BR/messages.js';
import ruRu from './locales/ru_RU/messages.js';
import svSe from './locales/sv_SE/messages.js';
import trTr from './locales/tr_TR/messages.js';
import zhCn from './locales/zh_CN/messages.js';
import deDe from './locales/de_DE/messages.js';

/**
 * Load up environment variables.
 * 9/2019 new api version: v2
 */
let logLevel = 'error';
let aUrl = 'https://api.connect.autodesk.com/v2/';
let tUrl = '//tags.tiqcdn.com/utag/autodesk/akp-clicktocall/prod/utag.js';
let aKey = "U8Z7qWEugj4zRL4r16c5g8b6ZRpkmfix7bdFoKpn";

if (process.env.REACT_APP_TIER === 'dev') {
  logLevel = 'debug';
  aUrl = 'https://api-dev.connect.autodesk.com/v2/';
  tUrl = '//tags.tiqcdn.com/utag/autodesk/akp-clicktocall-qa/qa/utag.js';
  aKey = "HEyk5PsUF8wwlH1TaUJTzK364ucMh38kRDd6BC70";
}

export const apiUrl = aUrl;
export const apiKey = aKey;
export const tealiumUrl = tUrl;

export const waitTimeTimeout = 60000;
export const totalMinutes = 5 * 60 * 1000;

log.setLevel(logLevel);
log.debug('Log Level', log.getLevel());
log.debug('Build', process.env.REACT_APP_TIER);

/**
 * Examples of log level
 */
// log.trace('trace');
// log.debug('debug');
// log.info('info');
// log.warn('warn default');
// log.error('error')

export const href = window.location.href;

/**
 * Returns domain of environment. Switches ports for testing.
 *
 * @returns { string } domain name
 */
function getDomain() {
  const domain =
    window.location.protocol + '//' + window.location.hostname + ':3000';
  return domain;
}

export const domain = getDomain();

export const catalogs = {
  cs_CZ: csCz,
  da_DK: daDk,
  de_CH: deCh,
  en_AU: enGb,
  en_GB: enGb,
  en_IN: enGb,
  en_NZ: enGb,
  en_SG: enGb,
  en_US: enUs,
  en_MY: enGb,
  es_MX: esMx,
  fr_CH: frCh,
  it_CH: itCh,
  ja_JP: jaJp,
  ko_KR: koKr,
  no_NO: noNo,
  pl_PL: plPl,
  pt_BR: ptBr,
  ru_RU: ruRu,
  sv_SE: svSe,
  tr_TR: trTr,
  zh_CN: zhCn,
  de_DE: deDe,
  es_AR: esMx
};

export const defaultLanguageCountry = 'en_US';

const countries = {
  cs_CZ: 'CZE',
  da_DK: 'DNK',
  de_CH: 'CHE',
  en_AU: 'AUS',
  en_GB: 'GBR',
  en_IN: 'IND',
  en_MY: 'MYS',
  en_NZ: 'NZL',
  en_SG: 'SGP',
  en_US: 'USA',
  es_MX: 'MEX',
  fr_CH: 'CHE',
  it_CH: 'CHE',
  ja_JP: 'JPN',
  ko_KR: 'KOR',
  no_NO: 'NOR',
  pl_PL: 'POL',
  pt_BR: 'BRA',
  ru_RU: 'RUS',
  sv_SE: 'SWE',
  tr_TR: 'TUR',
  zh_CN: 'CHN',
  de_DE: 'DEU',
  es_AR: 'ARG'
};

const languages = {
  cs_CZ: 'cs',
  da_DK: 'da',
  de_CH: 'de',
  en_AU: 'en',
  en_GB: 'gb',
  en_IN: 'en',
  en_MY: 'en',
  en_NZ: 'en',
  en_SG: 'en',
  en_US: 'en',
  es_MX: 'es',
  fr_CH: 'fr',
  it_CH: 'it',
  ja_JP: 'ja',
  ko_KR: 'ko',
  no_NO: 'no',
  pl_PL: 'pl',
  pt_BR: 'pt',
  ru_RU: 'ru',
  sv_SE: 'sv',
  tr_TR: 'tr',
  zh_CN: 'zh',
  de_DE: 'de',
  es_AR: 'es'
};

export const languageOptionList = {
  cs_CZ: 'cs_CZ',
  da_DK: 'da_DK',
  de_CH: 'de_CH',
  en_AU: 'en_AU',
  en_GB: 'en_GB',
  en_IN: 'en_IN',
  en_NZ: 'en_NZ',
  en_SG: 'en_SG',
  en_US: 'en_US',
  en_MY: 'en_MY',
  es_MX: 'es_MX',
  fr_CH: 'fr_CH',
  it_CH: 'it_CH',
  ja_JP: 'ja_JP',
  ko_KR: 'ko_KR',
  no_NO: 'no_NO',
  pl_PL: 'pl_PL',
  pt_BR: 'pt_BR',
  ru_RU: 'ru_RU',
  sv_SE: 'sv_SE',
  tr_TR: 'tr_TR',
  zh_CN: 'zh_CN',
  de_DE: 'de_DE',
  es_AR: 'es_AR'
};

/**
 * Gets the value stored in a map.
 *
 * @param { map } obj map
 * @param { string } key for map
 *
 * @returns { string } value
 */
function getMapValue(obj, key) {
  if (obj.hasOwnProperty(key)) {
    return obj[key];
  }
  throw new Error('Invalid map key');
}

/**
 * Gets the country based on the key.
 *
 * @param { string } key country
 * @returns { string } value country
 */
export function getCountry(key) {
  return getMapValue(countries, key);
}

/**
 * Gets the language based on the key.
 *
 * @param { string } key language
 * @returns { string } value language
 */
export function getLanguage(key) {
  return getMapValue(languages, key);
}

/*eslint-disable */
// Country  URL                                           Flyout Language     Support Languge
// Singpore               https://www.autodesk.com.sg/    English             English
// India                  https://www.autodesk.in/        British English     British English
// New Zealand            https://www.autodesk.co.nz/     British English     British English
// Australia              https://www.autodesk.com.au/    British English     British English
// Malasia                https://asean.autodesk.com/     English             English
// Korean                 https://www.autodesk.co.kr/     Korean              Korean
// Japanese               https://www.autodesk.co.jp/     Japanese            Japanese
// Simp Chinese           https://www.autodesk.com.cn/    Simplified Chinese  Simplified Chinese
// Brazil                 https://www.autodesk.com.br/    Brazil Portuguese   Brazil Portuguese
// Mexico                 https://www.autodesk.mx/        Spanish             Spanish
// Russian                https://www.autodesk.ru/        Russian             English
// Turkey                 https://www.autodesk.com.tr/    Turkish             English
// Poland                 https://www.autodesk.pl/        Polish              English
// Denmark                https://www.autodesk.dk/        Danish              English
// Czech Republic         https://www.autodesk.cz/        Czech               English
// Sweden                 https://www.autodesk.se/        Swedish             English
// Switzerland (French)   https://www.autodesk.ch/fr      French              French
// Switzerland (German)   https://www.autodesk.ch/de      German              German
// Switzerland (Italian)  https://www.autodesk.ch/it      Italian             Italian
// Norway                 https://www.autodesk.no/        Norwegian           English

// 1. en-US     eng-US    English
// 2. en-GB     eng-GB    British English
// 3. ko-KR     kor-KR    Korean
// 4. ja-JP     jpn-JP    Japanese
// 5. zh-CN     zho-CN    Simplified Chinese
// 6. pt-BR     por-BR    Brazilian Portuguese
// 7. es-ES     spa-ES    Spanish
// 8. ru-RU     rus-RU    Russian
// 9. tr-TR     tur-TR    Turkish
// 10. pl-PL    pol-PL    Polish
// 11. da-DA    dan-DA    Danish
// 12. cz-CS  (ce-CZ or ce-CS)  csy-CS    Czech
// 13. sv-SV    swe-SV    Swedish
// 14. fr-CH    fra-CH    Switzerland French
// 15. de-CH    deu-CH    Switzerland German
// 16. it-CH    ita-CH    Switzerland Italian
// 17. no-NO    nor-NO    Norwegian

/*
cze (B)
ces (T)
 designated as 'B' (bibliographic) or 'T' (terminology)
*/
